import PublicPageWrapper from 'components/wrappers/PublicPageWrapper'
import Head from 'next/head'
import SimpleStaticPageContent from 'components/page-content/SimpleStaticPageContent'
import introImage from '../public/images/index/index-intro-graphic.png'
import { privacyPolicyContent } from 'utils/StaticPagesData'

export default function PrivacyPolicy() {
  return (
    <div>
      <Head>
        <title>Privacy Policy | MyTags</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <PublicPageWrapper>

        <SimpleStaticPageContent
          title='Privacy Policy'
          subtitle='Last revised on: November 28th, 2022'
          heroImage={introImage}
          markdownContent={privacyPolicyContent}
        />

      </PublicPageWrapper>
    </div>
  )
}

export async function getStaticProps() {

  return {
    props: {},
    revalidate: 10,
  }
}
